import * as constants from '../constants';

export default function (state = [], action) {
  switch (action.type) {
    case constants.GET_USERS_SUCCESS:
      return Object.assign({},
        state, {
          users: action.users,
        });
    case constants.GET_USER_BY_ID_SUCCESS:
      return Object.assign({},
        state, {
          user: action.user,
        });
    case constants.GET_USERS_ERROR:
    case constants.GET_USER_BY_ID_ERROR:
      return {
        error: action.error,
      };
    default:
      return state;
  }
};
